// Adapter: Desarrollos entities → the input shape renderAnexoPdf expects.
//
// Desarrollos has a real package model (desarrollos_anexo_packages), and the
// workspace holds it NESTED — packages[].items[] — so this maps 1:1 over
// packages in a single pass, the same way the renderer already thinks.
//
// The `label` format is load-bearing. generateAnexoPDF splits it on the LAST
// " - ": everything before is the name drawn in the leftmost column, the tail
// is the package code whose trailing digits fill the "No. De PK" column. Pass a
// bare name and the PK column comes out empty. desarrollos_anexo_packages has
// no code column, so the code is derived here — never stored.

// ordenarPaquetes / aplanarItems viven ahora en el ledger compartido. Se
// importan (buildAnexoPdfInput usa ordenarPaquetes acá abajo) y se reexportan
// para no romper a quien ya los pedía desde este módulo.
import { ordenarPaquetes, aplanarItems } from '../../components/anexo/helpers';

export { ordenarPaquetes, aplanarItems };

// Rate applied to the CIP total for the tax column of the DGA form.
export const TASA_IMPUESTO = 0.145;

export const shortAnexoId = (id) => String(id || '').slice(0, 8).toUpperCase();

// sort_order 0 → PK-01, 1 → PK-02. Derivación pura, sin columna en la base.
export const codigoPaquete = (pkg) =>
  `PK-${String((pkg?.sort_order ?? 0) + 1).padStart(2, '0')}`;

// Un paquete sin nombre nunca debe imprimirse con la cabecera en blanco. Este
// respaldo es SOLO de presentación — no se persiste.
export const nombreParaMostrar = (pkg) =>
  pkg?.nombre?.trim() || `Paquete ${(pkg?.sort_order ?? 0) + 1}`;

const mapItemForPdf = (it) => {
  const cip = Number(it.cip_total_usd);
  return {
    description: it.descripcion || '',
    quantity: Number(it.cantidad) || 1,
    unit_value: Number(it.fob_unitario_usd) || 0,
    condition: 'NUEVO',
    // Blank CIP prints as 0.00 rather than guessing a value.
    tax_amount: Number.isFinite(cip) ? cip * TASA_IMPUESTO : 0,
  };
};

// Pure on purpose: the preview rebuilds from live workspace state on the 3 s
// beat, so this must not go to the network.
export const buildAnexoPdfInput = ({ anexo, cliente, perfil, packages }) => {
  const ordenados = ordenarPaquetes(packages);

  const sortedPackages = ordenados.map((pkg) => ({
    // _seq viene de sort_order: distinto por paquete y es lo que el renderer
    // usa para skipSeqs / onlySeq.
    _seq: (pkg.sort_order ?? 0) + 1,
    label: `${nombreParaMostrar(pkg).toUpperCase()} - ${codigoPaquete(pkg)}`,
    taxes: { dai: 0 },
    items: (pkg.items || []).map(mapItemForPdf),
  }));

  return {
    draft: { confirmed_at: anexo?.completed_at || new Date().toISOString() },
    config: {
      gestor_code: perfil?.codigo_gestor || '',
      aduana_code: perfil?.codigo_aduana || '',
      gestor_name: perfil?.nombre_gestor || '',
      registro_prefix: perfil?.no_registro || '',
    },
    sortedPackages,
  };
};

// A row is printable only with all three required fields present.
export const itemIncompleto = (it) =>
  !String(it.descripcion || '').trim() ||
  !(Number(it.cantidad) > 0) ||
  !(Number(it.fob_unitario_usd) >= 0) ||
  it.fob_unitario_usd === null ||
  it.fob_unitario_usd === undefined ||
  it.fob_unitario_usd === '';
